// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cx-sidebar .cx-sidebar-wrapper {
  transition: all 0.5s;
  width: 250px;
  background: #fff;
  position: fixed;
  z-index: 55;
  height: 100vh;
}
.cx-sidebar .cx-sidebar-wrapper aside .logo-main {
  align-items: center;
  display: flex;
  height: 60px;
  justify-content: start;
  padding: 0 20px;
}
.cx-sidebar .cx-sidebar-wrapper aside .logo-main .big img {
  width: 200px;
  height: 50px;
}
.cx-sidebar .cx-sidebar-wrapper aside .logo-main .small img {
  width: 100%;
  height: 40px;
}
.cx-sidebar .cx-sidebar-wrapper aside .displayNone .left {
  display: none !important;
}
.cx-sidebar .cx-sidebar-wrapper aside .top-logo-big {
  padding: 30px 0;
  background: linear-gradient(150deg, #1e384b 0%, #44667f 100%);
}
.cx-sidebar .cx-sidebar-wrapper aside .top-logo-big .left {
  text-align: center;
}
.cx-sidebar .cx-sidebar-wrapper aside .top-logo-big .left h6 {
  font-size: 20px !important;
  color: #cdcee2 !important;
}
.cx-sidebar .cx-sidebar-wrapper aside .top-logo-big span {
  color: #fff;
  font-size: 14px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main {
  position: relative;
  transition: all 0.5s;
  height: calc(100vh - 100px);
  overflow-y: auto;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main a {
  text-decoration: none;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menu-name {
  letter-spacing: 0.38px;
  color: #055D9D;
  font-size: 14px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main #arrow-double {
  border-top: 1px solid rgba(132, 133, 157, 0.5294117647);
  background-color: transparent;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main #arrow-double #arrow-inner img {
  cursor: pointer;
  padding-right: 15px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .active-menu-sidebar {
  background: linear-gradient(90deg, #E40288 0.63%, #055D9D 97.5%);
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .active-menu-sidebar .menu-name {
  color: #fff;
  font-weight: 600;
  letter-spacing: 1px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .sub-menu-main .active-sub-menu {
  color: #055D9D !important;
  font-weight: 600;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .sub-menu-main .sub-menu {
  padding: 10px 10px 0px 50px;
  letter-spacing: 0.38px;
  color: #707070;
  font-size: 14px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .sub-menu-main .sub-menu-item {
  margin-top: 10px;
  display: block;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items {
  padding: 15px 0;
  border-bottom: 1px solid rgba(132, 133, 157, 0.5294117647);
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name {
  display: block;
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-left: 15px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name img {
  height: 24px;
  width: 24px;
  margin-left: 3px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name svg {
  height: 24px;
  width: 24px;
  margin-left: 3px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name-arrow {
  display: flex;
  justify-content: space-between;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name-arrow .menu-left {
  display: flex;
  align-items: center;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name-arrow .menu-left .icon-left {
  margin-right: 15px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .menus-items .icon-menu-name-arrow .menu-left .icon-left svg {
  height: 21px;
  margin-left: 3px;
  width: 21px;
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .sub-menus {
  margin-bottom: 30px;
  transition: all 0.5s;
  margin-left: 11px;
  border-left: 1px solid var(--green_3DA298_LightMode);
}
.cx-sidebar .cx-sidebar-wrapper aside .menus-main .sub-menus .sub-menue-items {
  margin-bottom: 15px;
  display: block;
  margin-left: 24px;
}

.sidebarActive {
  transition: all 0.3s;
  width: 60px !important;
  transition: all 0.5s;
}
.sidebarActive .menus-main #arrow-double #arrow-inner img {
  padding-right: unset !important;
}
.sidebarActive .logo-main {
  transition: all 0.3s;
  padding: 0 10px !important;
}
.sidebarActive label {
  color: #ffffff;
  font-size: 12px;
}

.doubleArrowActive {
  transform: rotate(180deg) !important;
  text-align: center !important;
  transition: all 0.5s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/sidebar.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AAAJ;AAGM;EAaE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAbR;AAFU;EACE,YAAA;EACA,YAAA;AAIZ;AAAU;EACE,WAAA;EACA,YAAA;AAEZ;AAQQ;EACE,wBAAA;AANV;AASM;EACE,eAAA;EAWA,6DAAA;AAjBR;AAQQ;EACE,kBAAA;AANV;AAQU;EACE,0BAAA;EACA,yBAAA;AANZ;AAYQ;EACE,WAAA;EACA,eAAA;AAVV;AAcM;EACE,kBAAA;EACA,oBAAA;EAEA,2BAAA;EACA,gBAAA;AAbR;AAeQ;EACE,qBAAA;AAbV;AAgBQ;EACE,sBAAA;EACA,cAAA;EACA,eAAA;AAdV;AAiBQ;EACE,uDAAA;EACA,6BAAA;AAfV;AAoBY;EACE,eAAA;EACA,mBAAA;AAlBd;AAuBQ;EACE,gEAAA;AArBV;AAsBU;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AApBZ;AAwBU;EACE,yBAAA;EACA,gBAAA;AAtBZ;AAwBU;EACE,2BAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAtBZ;AAwBU;EACE,gBAAA;EACA,cAAA;AAtBZ;AAyBQ;EACE,eAAA;EACA,0DAAA;AAvBV;AAyBU;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AAvBZ;AAyBY;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAvBd;AAyBY;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAvBd;AA2BU;EACE,aAAA;EACA,8BAAA;AAzBZ;AA2BY;EACE,aAAA;EACA,mBAAA;AAzBd;AA2Bc;EACE,kBAAA;AAzBhB;AA2BgB;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAzBlB;AAgCQ;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oDAAA;AA9BV;AAgCU;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;AA9BZ;;AAsCA;EAIE,oBAAA;EAMA,sBAAA;EAEA,oBAAA;AA5CF;AAiCE;EACE,+BAAA;AA/BJ;AAmCE;EACE,oBAAA;EACA,0BAAA;AAjCJ;AAuCE;EACE,cAAA;EACA,eAAA;AArCJ;;AAyCA;EACE,oCAAA;EACA,6BAAA;EACA,oBAAA;AAtCF","sourcesContent":[".cx-sidebar {\n  .cx-sidebar-wrapper {\n    transition: all 0.5s;\n    width: 250px;\n    background: #fff;\n    position: fixed;\n    z-index: 55;\n    height: 100vh;\n\n    aside {\n      .logo-main {\n        .big {\n          img {\n            width: 200px;\n            height: 50px;\n          }\n        }\n        .small {\n          img {\n            width: 100%;\n            height: 40px;\n          }\n        }\n        align-items: center;\n        display: flex;\n        height: 60px;\n        justify-content: start;\n        padding: 0 20px;\n      }\n      .displayNone {\n        .left {\n          display: none !important;\n        }\n      }\n      .top-logo-big {\n        padding: 30px 0;\n\n        .left {\n          text-align: center;\n\n          h6 {\n            font-size: 20px !important;\n            color: #cdcee2 !important;\n          }\n        }\n\n        background: linear-gradient(150deg, #1e384b 0%, #44667f 100%);\n\n        span {\n          color: #fff;\n          font-size: 14px;\n        }\n      }\n\n      .menus-main {\n        position: relative;\n        transition: all 0.5s;\n\n        height: calc(100vh - 100px);\n        overflow-y: auto;\n\n        a {\n          text-decoration: none;\n        }\n\n        .menu-name {\n          letter-spacing: 0.38px;\n          color: #055D9D;\n          font-size: 14px;\n        }\n\n        #arrow-double {\n          border-top: 1px solid #84859d87;\n          background-color: transparent;\n\n          #arrow-inner {\n            // padding: 0 20px;\n\n            img {\n              cursor: pointer;\n              padding-right: 15px;\n            }\n          }\n        }\n\n        .active-menu-sidebar {\n          background: linear-gradient(90deg, #E40288 0.63%, #055D9D 97.5%);\n          .menu-name {\n            color: #fff;\n            font-weight: 600;\n            letter-spacing: 1px;\n          }\n        }\n        .sub-menu-main {\n          .active-sub-menu {\n            color: #055D9D !important;\n            font-weight: 600;\n          }\n          .sub-menu {\n            padding: 10px 10px 0px 50px;\n            letter-spacing: 0.38px;\n            color: #707070;\n            font-size: 14px;\n          }\n          .sub-menu-item {\n            margin-top: 10px;\n            display: block;\n          }\n        }\n        .menus-items {\n          padding: 15px 0;\n          border-bottom: 1px solid #84859d87;\n\n          .icon-menu-name {\n            display: block;\n            display: flex;\n            align-items: center;\n            text-decoration: none;\n            margin-left: 15px;\n\n            img {\n              height: 24px;\n              width: 24px;\n              margin-left: 3px;\n            }\n            svg {\n              height: 24px;\n              width: 24px;\n              margin-left: 3px;\n            }\n          }\n\n          .icon-menu-name-arrow {\n            display: flex;\n            justify-content: space-between;\n\n            .menu-left {\n              display: flex;\n              align-items: center;\n\n              .icon-left {\n                margin-right: 15px;\n\n                svg {\n                  height: 21px;\n                  margin-left: 3px;\n                  width: 21px;\n                }\n              }\n            }\n          }\n        }\n\n        .sub-menus {\n          margin-bottom: 30px;\n          transition: all 0.5s;\n          margin-left: 11px;\n          border-left: 1px solid var(--green_3DA298_LightMode);\n\n          .sub-menue-items {\n            margin-bottom: 15px;\n            display: block;\n            margin-left: 24px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.sidebarActive {\n  .menus-main #arrow-double #arrow-inner img{\n    padding-right: unset !important;\n  }\n  transition: all 0.3s;\n\n  .logo-main {\n    transition: all 0.3s;\n    padding: 0 10px !important;\n  }\n  width: 60px !important;\n  // padding: 15px !important;\n  transition: all 0.5s;\n\n  label {\n    color: #ffffff;\n    font-size: 12px;\n  }\n}\n\n.doubleArrowActive {\n  transform: rotate(180deg) !important;\n  text-align: center !important;\n  transition: all 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
